import styled from "@emotion/styled";
import {Flex} from "antd";

export const Col = styled(Flex)`
  flex-direction: column;
  width: 100%;
`
